import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import { MoralisProvider } from "react-moralis";
import { Web3OnboardProvider, init } from "@web3-onboard/react";
import { AcreDappProvider } from "./providers/AcreDappProvider/AcreDappProvider";
import injectedModule from "@web3-onboard/injected-wallets";
import reportWebVitals from "./reportWebVitals";

const Application = () => {
  const ALCHEMY_API_KEY = process.env.REACT_APP_ALCHEMY_API_KEY;
  const APP_ID = process.env.REACT_APP_MORALIS_APPLICATION_ID;
  const SERVER_URL = process.env.REACT_APP_MORALIS_SERVER_URL;
  const injected = injectedModule();
  const network = "mainnet";
  // Only one RPC endpoint required per chain
  const rpcAPIKey = `${ALCHEMY_API_KEY}`;
  const rpcUrl = `https://eth-goerli.g.alchemy.com/v2/${rpcAPIKey}`;

  // initialize Onboard
  const web3onboard = init({
    wallets: [injected],
    chains: [
      {
        id: network == "mainnet" ? "0x1" : "5",
        token: "ETH",
        label: "Goerli Testnet",
        rpcUrl,
      },
    ],
  });
  return (
    <MoralisProvider appId={`${APP_ID}`} serverUrl={`${SERVER_URL}`}>
      <Web3OnboardProvider web3Onboard={web3onboard}>
        <AcreDappProvider>
          <App />
        </AcreDappProvider>
      </Web3OnboardProvider>
    </MoralisProvider>
  );
};
const container = document.getElementById('root') as Element;
const root = createRoot(container);
root.render(
    <Application />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
